export const chargeQuiterModalTypes = {
  getDealerNumber: 'getDealerNumber',
  showDealerNumber: 'showDealerNumber',
  showVehicleInfo: 'showVehicleInfo',
  showResultInfo: 'showResultInfo'
}
